import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Button, Result, Skeleton } from "antd";
import { useTranslation } from 'react-i18next';

import { fetchCartProducts, fetchSuccessPage } from "store/slices/cartSlice";
import Breadcrumb from "components/Breadcrumb";
import useSmartNavigate from "hooks/useSmartNavigate";
import { loadingStatus } from "helpers/fetcher";

const Success = () => {
  const { t } = useTranslation();
  const { navigate } = useSmartNavigate();
  const dispatch = useDispatch();
  const { "*": orderId } = useParams();
  const { data, status } = useSelector((state) => state.cart.successPage);

  useEffect(() => {
    dispatch(fetchSuccessPage(orderId));
    dispatch(fetchCartProducts({ refetchAfterMutation: true }));
  }, [dispatch, orderId]);

  return (
    <div className="region">
      <Breadcrumb />
      <div className="white p-30">
        {loadingStatus.SUCCEEDED === status ? (
          <Result
            status="success"
            title={data.order_text}
            subTitle={
              <>
                <p>{t('success.orderProcessing')}</p>
                <br />
                <p>{t('success.orderSmsInfo')}</p>
                <p>Вы можете просматривать историю заказов в <Button type="link" onClick={() => navigate("/account")}>{t('success.personalAccount')}</Button></p>
              </>
            }
            extra={[
              <Button key="continue" type="primary" onClick={() => navigate("/catalog")}>
                {t('success.continueShopping')}
              </Button>
            ]}
          />
        ) : (
          <Skeleton active paragraph={{ rows: 6 }} />
        )}
      </div>
    </div>
  );
};

export default Success;
